// extracted by mini-css-extract-plugin
module.exports = {"textBadgeContainer":"CardTag_textBadgeContainer__LXjTC"};